import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { persistCombineReducers } from 'redux-persist';
import { combineEpics } from 'redux-observable';
import { reducer as formReducer } from 'redux-form';

import persistConfig from 'store/persistConfig';

import auth from 'modules/auth/reducers';
import messageSystem from 'modules/messageSystem/reducers';
import conference from 'modules/conference/reducers';
import appointmentInfo from 'modules/appointmentInfo/reducers';
import session from 'modules/session/reducers';
import common from 'modules/common/reducers';
import user from 'modules/user/reducers';
import reschedulingOffer from 'modules/reschedulingOffer/reducers';
import appointmentsManagement from 'modules/appointmentsManagement/reducers';

import queuesCommon from 'modules/queues/common/reducers';
import queuesSchedule from 'modules/queues/Schedule/reducers';
import queuesArchive from 'modules/queues/Archive/reducers';


import authorizationEpics from 'modules/auth/epics';
import sessionEpics from 'modules/session/epics';
import conferenceEpics from 'modules/conference/epics';
import messageSystemEpics from 'modules/messageSystem/epics';
import queuesScheduleEpics from 'modules/queues/common/epics';
import { appointmentsUpdatesEpics } from 'modules/queues/common/AppointmentsUpdatesManager';

export const rootReducer = history => persistCombineReducers(persistConfig, {
  router: connectRouter(history),
  form: formReducer,
  auth,
  messageSystem,
  session,
  user,
  conference,
  appointmentInfo,
  appointmentsManagement,
  common,
  reschedulingOffer,
  queues: combineReducers({
    common: queuesCommon,
    schedule: queuesSchedule,
    archive: queuesArchive,
  }),
});

export const rootEpic = combineEpics(
  authorizationEpics,
  sessionEpics,
  conferenceEpics,
  messageSystemEpics,
  appointmentsUpdatesEpics,
  queuesScheduleEpics,
);
